import * as URLPlus from './index.js';

if (!globalThis.webqit) globalThis.webqit = {}
Object.assign(globalThis.webqit, URLPlus);